import type { UseQueryReturnType } from '@tanstack/vue-query';

import waitQueryPromiseHelper from './waitQueryPromiseHelper';

/**
 * Wait query isLoading flag
 */
export default function waitQueryLoaded<T, TError>(query: UseQueryReturnType<T, TError>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const { data, isPending, error } = query;
    waitQueryPromiseHelper(isPending, data, error, resolve, reject, true);
  });
}
